// NSE F&O stock universe: [symbol, sector, approximate reference price].
// Reference prices only seed the simulator; live feeds replace them.
export type UniverseRow = [symbol: string, sector: string, refPrice: number];

export const SECTORS = ["REALTY","CAP GOODS","AUTO","CEMENT","POWER","CONSUMER","NBFC","BANK","PSU BANK","DEFENCE","METAL","CHEM","FMCG","IT","INSURANCE","OIL & GAS","CAP MKTS","TELECOM","LOGISTICS","NEW-AGE","PHARMA"] as const;

export const FNO_UNIVERSE: UniverseRow[] = [
  ["DLF", "REALTY", 820],
  ["GODREJPROP", "REALTY", 2300],
  ["LODHA", "REALTY", 1250],
  ["OBEROIRLTY", "REALTY", 1700],
  ["PRESTIGE", "REALTY", 1600],
  ["PHOENIXLTD", "REALTY", 1650],
  ["NBCC", "REALTY", 110],
  ["ABB", "CAP GOODS", 5600],
  ["SIEMENS", "CAP GOODS", 3200],
  ["CGPOWER", "CAP GOODS", 680],
  ["BHEL", "CAP GOODS", 240],
  ["LT", "CAP GOODS", 3600],
  ["CUMMINSIND", "CAP GOODS", 3500],
  ["POLYCAB", "CAP GOODS", 6800],
  ["KEI", "CAP GOODS", 3900],
  ["SUPREMEIND", "CAP GOODS", 4300],
  ["APLAPOLLO", "CAP GOODS", 1700],
  ["INOXWIND", "CAP GOODS", 160],
  ["SUZLON", "CAP GOODS", 62],
  ["KAYNES", "CAP GOODS", 6000],
  ["DIXON", "CAP GOODS", 16000],
  ["ADANIENT", "CAP GOODS", 2400],
  ["HAVELLS", "CAP GOODS", 1550],
  ["M&M", "AUTO", 3400],
  ["MARUTI", "AUTO", 12500],
  ["TMPV", "AUTO", 400],
  ["BAJAJ-AUTO", "AUTO", 8800],
  ["HEROMOTOCO", "AUTO", 5400],
  ["EICHERMOT", "AUTO", 6900],
  ["TVSMOTOR", "AUTO", 3400],
  ["ASHOKLEY", "AUTO", 140],
  ["BHARATFORG", "AUTO", 1300],
  ["MOTHERSON", "AUTO", 105],
  ["BOSCHLTD", "AUTO", 38000],
  ["EXIDEIND", "AUTO", 390],
  ["HYUNDAI", "AUTO", 2400],
  ["TIINDIA", "AUTO", 3000],
  ["SONACOMS", "AUTO", 480],
  ["UNOMINDA", "AUTO", 1250],
  ["ULTRACEMCO", "CEMENT", 12000],
  ["SHREECEM", "CEMENT", 29000],
  ["AMBUJACEM", "CEMENT", 570],
  ["DALBHARAT", "CEMENT", 2200],
  ["GRASIM", "CEMENT", 2800],
  ["NTPC", "POWER", 340],
  ["POWERGRID", "POWER", 290],
  ["TATAPOWER", "POWER", 390],
  ["ADANIPOWER", "POWER", 200],
  ["ADANIGREEN", "POWER", 1000],
  ["ADANIENSOL", "POWER", 950],
  ["JSWENERGY", "POWER", 520],
  ["NHPC", "POWER", 85],
  ["IEX", "POWER", 140],
  ["TORNTPOWER", "POWER", 1300],
  ["TITAN", "CONSUMER", 3600],
  ["ASIANPAINT", "CONSUMER", 2400],
  ["PIDILITIND", "CONSUMER", 1500],
  ["TRENT", "CONSUMER", 4700],
  ["DMART", "CONSUMER", 4200],
  ["JUBLFOOD", "CONSUMER", 480],
  ["VOLTAS", "CONSUMER", 1350],
  ["BLUESTARCO", "CONSUMER", 1550],
  ["AMBER", "CONSUMER", 7000],
  ["PAGEIND", "CONSUMER", 45000],
  ["KALYANKJIL", "CONSUMER", 500],
  ["INDHOTEL", "CONSUMER", 750],
  ["BAJFINANCE", "NBFC", 1000],
  ["BAJAJFINSV", "NBFC", 2000],
  ["CHOLAFIN", "NBFC", 1600],
  ["SHRIRAMFIN", "NBFC", 650],
  ["MUTHOOTFIN", "NBFC", 3000],
  ["MANAPPURAM", "NBFC", 280],
  ["LICHSGFIN", "NBFC", 580],
  ["PNBHOUSING", "NBFC", 900],
  ["IREDA", "NBFC", 115],
  ["PFC", "NBFC", 400],
  ["RECLTD", "NBFC", 380],
  ["SAMMAANCAP", "NBFC", 160],
  ["LTF", "NBFC", 250],
  ["JIOFIN", "NBFC", 300],
  ["HDFCBANK", "BANK", 990],
  ["ICICIBANK", "BANK", 1380],
  ["AXISBANK", "BANK", 1200],
  ["KOTAKBANK", "BANK", 2100],
  ["INDUSINDBK", "BANK", 750],
  ["FEDERALBNK", "BANK", 210],
  ["IDFCFIRSTB", "BANK", 72],
  ["BANDHANBNK", "BANK", 165],
  ["AUBANK", "BANK", 750],
  ["RBLBANK", "BANK", 280],
  ["YESBANK", "BANK", 22],
  ["SBIN", "PSU BANK", 880],
  ["BANKBARODA", "PSU BANK", 250],
  ["PNB", "PSU BANK", 115],
  ["CANBK", "PSU BANK", 125],
  ["UNIONBANK", "PSU BANK", 140],
  ["BANKINDIA", "PSU BANK", 125],
  ["INDIANB", "PSU BANK", 750],
  ["MAHABANK", "PSU BANK", 58],
  ["HAL", "DEFENCE", 4700],
  ["BEL", "DEFENCE", 410],
  ["BDL", "DEFENCE", 1600],
  ["MAZDOCK", "DEFENCE", 2800],
  ["COCHINSHIP", "DEFENCE", 1800],
  ["SOLARINDS", "DEFENCE", 14000],
  ["TATASTEEL", "METAL", 170],
  ["JSWSTEEL", "METAL", 1150],
  ["HINDALCO", "METAL", 780],
  ["VEDL", "METAL", 470],
  ["JINDALSTEL", "METAL", 1050],
  ["SAIL", "METAL", 135],
  ["NMDC", "METAL", 75],
  ["NATIONALUM", "METAL", 220],
  ["HINDZINC", "METAL", 480],
  ["COALINDIA", "METAL", 390],
  ["PIIND", "CHEM", 3700],
  ["UPL", "CHEM", 700],
  ["SRF", "CHEM", 2900],
  ["TATACHEM", "CHEM", 900],
  ["DEEPAKNTR", "CHEM", 1900],
  ["HINDUNILVR", "FMCG", 2500],
  ["ITC", "FMCG", 410],
  ["NESTLEIND", "FMCG", 1200],
  ["BRITANNIA", "FMCG", 6000],
  ["DABUR", "FMCG", 520],
  ["MARICO", "FMCG", 720],
  ["GODREJCP", "FMCG", 1200],
  ["COLPAL", "FMCG", 2200],
  ["TATACONSUM", "FMCG", 1100],
  ["VBL", "FMCG", 470],
  ["UNITDSPR", "FMCG", 1350],
  ["PATANJALI", "FMCG", 600],
  ["TCS", "IT", 3000],
  ["INFY", "IT", 1500],
  ["HCLTECH", "IT", 1450],
  ["WIPRO", "IT", 250],
  ["TECHM", "IT", 1450],
  ["LTM", "IT", 4070],
  ["PERSISTENT", "IT", 5500],
  ["COFORGE", "IT", 1700],
  ["MPHASIS", "IT", 2800],
  ["OFSS", "IT", 8500],
  ["KPITTECH", "IT", 1200],
  ["TATAELXSI", "IT", 5400],
  ["TATATECH", "IT", 700],
  ["HDFCLIFE", "INSURANCE", 760],
  ["SBILIFE", "INSURANCE", 1800],
  ["ICICIGI", "INSURANCE", 1950],
  ["ICICIPRULI", "INSURANCE", 600],
  ["LICI", "INSURANCE", 900],
  ["MFSL", "INSURANCE", 1550],
  ["RELIANCE", "OIL & GAS", 1400],
  ["ONGC", "OIL & GAS", 245],
  ["BPCL", "OIL & GAS", 340],
  ["IOC", "OIL & GAS", 150],
  ["HINDPETRO", "OIL & GAS", 450],
  ["GAIL", "OIL & GAS", 180],
  ["PETRONET", "OIL & GAS", 280],
  ["OIL", "OIL & GAS", 420],
  ["IGL", "OIL & GAS", 210],
  ["BSE", "CAP MKTS", 2300],
  ["MCX", "CAP MKTS", 3300],
  ["ANGELONE", "CAP MKTS", 2400],
  ["CDSL", "CAP MKTS", 1550],
  ["CAMS", "CAP MKTS", 3800],
  ["KFINTECH", "CAP MKTS", 1100],
  ["HDFCAMC", "CAP MKTS", 5500],
  ["NUVAMA", "CAP MKTS", 6500],
  ["360ONE", "CAP MKTS", 1100],
  ["BHARTIARTL", "TELECOM", 1900],
  ["IDEA", "TELECOM", 8],
  ["INDUSTOWER", "TELECOM", 350],
  ["ADANIPORTS", "LOGISTICS", 1400],
  ["CONCOR", "LOGISTICS", 560],
  ["DELHIVERY", "LOGISTICS", 450],
  ["INDIGO", "LOGISTICS", 5600],
  ["GMRAIRPORT", "LOGISTICS", 88],
  ["IRCTC", "LOGISTICS", 720],
  ["ETERNAL", "NEW-AGE", 330],
  ["PAYTM", "NEW-AGE", 1250],
  ["NYKAA", "NEW-AGE", 230],
  ["POLICYBZR", "NEW-AGE", 1800],
  ["SWIGGY", "NEW-AGE", 420],
  ["NAUKRI", "NEW-AGE", 1400],
  ["SUNPHARMA", "PHARMA", 1650],
  ["DRREDDY", "PHARMA", 1250],
  ["CIPLA", "PHARMA", 1550],
  ["DIVISLAB", "PHARMA", 6000],
  ["LUPIN", "PHARMA", 1950],
  ["AUROPHARMA", "PHARMA", 1100],
  ["ZYDUSLIFE", "PHARMA", 980],
  ["TORNTPHARM", "PHARMA", 3500],
  ["ALKEM", "PHARMA", 5400],
  ["GLENMARK", "PHARMA", 1900],
  ["BIOCON", "PHARMA", 350],
  ["LAURUSLABS", "PHARMA", 850],
  ["MANKIND", "PHARMA", 2500],
  ["APOLLOHOSP", "PHARMA", 7600],
  ["MAXHEALTH", "PHARMA", 1150],
  ["FORTIS", "PHARMA", 900],
  ["SAGILITY", "PHARMA", 45],
  ["SYNGENE", "PHARMA", 650],
];
